import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Accounts, Conclusions, Kpi, TextSlides, Totals } from "@app/_models";
import { AuthenticationService } from "@app/_services";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { ChartDataSets, ChartType } from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Label } from "ng2-charts";
import { Observable } from "rxjs";
import { AppComponent } from "@app/app.component";
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: "app-file-simple",
  templateUrl: "./file-simple.component.html",
  styleUrls: ["./file-simple.component.css"],
})
export class FileSimpleComponent implements OnInit {
  apiUrl = null;
  totals: Observable<Totals[]>;
  accounts: Observable<Accounts[]>;
  kpis: Observable<Kpi[]>;
  conclusions: Observable<Conclusions[]>;
  slides: Observable<TextSlides[]>;
  public account: any = [];
  public total: any = [];
  public kpi: any = [];
  public allKpi: any = [];
  public conclusion: any = [];
  public textSlides: any = [];
  loadingAccounts = true;
  loadingTotals = true;
  loadingKpi = true;
  loadingConclusions = true;
  loadingSlides = true;
  loadingExport = true;
  loadingDownload = false;
  expandSet = new Set<number>();
  expandedTables = new Set<string>();
  columnNames: any = [];
  columnNames2: any = [];
  chartConclusionsColNames: any = [];
  userRole = null;
  fileMonthYear: String;
  fileMonth: String;
  fileMonthNumeric: Number;
  fileYear: String;
  sysLanguage = "ro";
  isLanguageSelectorVisible = true;
  loadingDiagnostic = false;
  bodyContent: String;
  isMobile: boolean = false;

  counter: number;
  length: number;
  pdf: jsPDF;
  allPanelsExpanded: boolean = false;

  // Email functionality
  showEmailForm: boolean = false;
  recipientEmail: string = '';
  sendingEmail: boolean = false;

  // Notes functionality
  showNotesForm: boolean = false;
  fileNotes: string = '';
  savingNotes: boolean = false;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, private router: Router, private http: HttpClient, private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer, private el: ElementRef, public _api: ApiBackendService, private app: AppComponent, private message: NzMessageService) {
    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    }
    this.userRole = this.authenticationService.currentUserInfo.role;
    this.apiUrl = this.authenticationService.apiUrl;
    this.fileMonthYear = localStorage.getItem("fileMonthYear");
    this.fileMonth = localStorage.getItem("fileMonth");
    this.fileYear = localStorage.getItem("fileYear");
    this.fileMonthNumeric = Number(localStorage.getItem("fileMonthNumeric"));
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  isTableExpanded(tableId: string): boolean {
    return this.expandedTables.has(tableId);
  }

  toggleAllTotalsExpand(totals: any[], tableId: string = 'default'): void {
    const expanding = !this.expandedTables.has(tableId);
    if (expanding) {
      this.expandedTables.add(tableId);
      for (const row of totals) {
        if (this.isNum(row.accountTypeId)) {
          this.expandSet.add(row.id);
        }
        if (row.group) {
          for (const group of row.group) {
            if (this.isNum(group.accountTypeId)) {
              this.expandSet.add(group.id);
            }
          }
        }
      }
    } else {
      this.expandedTables.delete(tableId);
      for (const row of totals) {
        this.expandSet.delete(row.id);
        if (row.group) {
          for (const group of row.group) {
            this.expandSet.delete(group.id);
          }
        }
      }
    }
  }

  isNum(value) {
    if (Number(value)) {
      return true;
    }
    return false;
  }

  ngOnInit() {
    this.app.switchLanguage(this.sysLanguage);
    window.scrollTo(0, 0);
    this.checkIfMobile();

    // Load file notes
    this.loadFileNotes();

    const fileId = this.route.snapshot.paramMap.get("id");
    this._api.getFileDiag(fileId, this.sysLanguage).subscribe((response: any) => {
      this.loadingDiagnostic = true;
      this.bodyContent = response.body.content;
      console.log(response);
    });

    const processId = this.activatedRoute.snapshot.params.id;

    console.log("init");
    this._api
      .getTotals(processId)
      .pipe()
      .subscribe(
        (res) => {
          this.total = res.body;
          this.loadingTotals = false;
        },
        (err) => {
          this.router.navigate(["/files"]);
        }
      );

    this._api
      .getAccounts(processId)
      .pipe()
      .subscribe(
        (res) => {
          this.account = res.body;
          this.loadingAccounts = false;
        },
        (err) => { }
      );

    this._api
      .getKpis(processId)
      .pipe()
      .subscribe(
        (res) => {
          this.kpi = res.body;
          this.loadingKpi = false;
        },
        (err) => { }
      );

    this._api
      .getAllKpis()
      .pipe()
      .subscribe(
        (res) => {
          this.allKpi = res.body;
        },
        (err) => { }
      );

    this._api
      .getConclusions(processId)
      .pipe()
      .subscribe(
        (res) => {
          this.conclusion = res.body;
          this.loadingConclusions = false;
        },
        (err) => { }
      );

    this._api
      .getTextSlidesByLang(processId, this.sysLanguage)
      .pipe()
      .subscribe(
        (res) => {
          this.textSlides = res.body;
          this.loadingSlides = false;
          this.loadingExport = false;

          let tempValues = [];

          for (let val of this.textSlides) {
            if (val.chartType == "bar") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempLabels = [];

              let itemCounts = val.accounts.length;
              let itemCounts2 = val.accounts2.length;
              for (let idAcc of Object.keys(val.accounts)) {
                let acc = val.accounts[idAcc];
                if (acc != null) {
                  tempColumnsNames = ["", "Valoare", { role: "style" }];
                  tempDataAccounts.push([acc.account_description, acc.value]);
                }
              }

              for (let idAcc2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[idAcc2];
                if (acc2 != null) {
                  tempColumnsNames2 = ["", "Valoare", { role: "style" }];
                  tempDataAccounts2.push([acc2.account_description, acc2.value]);
                }
              }

              let i = 0;
              for (let conclusion of this.conclusion) {
                let acc = val.tableName;
                if (acc != null && conclusion[acc] != null) {
                  for (let concValue of conclusion[acc]) {
                    if (concValue[concValue.length - 1] != null) {
                      tempDataAccounts.push([concValue[concValue.length - 2], concValue[concValue.length - 1]]);
                      tempColumnsNames = ["", "Valoare", { role: "style" }];
                      i++;
                    }
                  }
                }
              }

              this.columnNames[val.id] = tempColumnsNames;
              this.columnNames2[val.id] = tempColumnsNames2;
            } else if (val.chartType == "pie") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempConclusionsColNames: any[] = [""];
              let tempLabels = [];
              let tempConclusions = [];

              tempColumnsNames.push("Valoare");
              tempColumnsNames2.push("Valoare");
              for (let account of Object.keys(val.accounts)) {
                let acc = val.accounts[account];
                if (acc != null && acc.value >= 0) {
                  tempDataAccounts.push([acc.account_description, acc.value]);
                }
              }

              for (let account2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[account2];
                if (acc2 != null && acc2.value >= 0) {
                  tempDataAccounts2.push([acc2.account_description, acc2.value]);
                }
              }

              for (let conclusion of this.conclusion) {
                let acc = val.tableName;
                if (acc != null && conclusion[acc] != null) {
                  for (let concValue of conclusion[acc]) {
                    tempConclusions.push([concValue[0], concValue[1]]);
                  }
                }
              }

              this.columnNames[val.id] = tempColumnsNames;
              this.columnNames2[val.id] = tempColumnsNames2;
            } else if (val.chartType == "stackedBar") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempConclusionsColNames: any[] = [""];
              let tempLabels = [];
              let tempConclusions = [];

              tempDataAccounts.push("");
              for (let account of Object.keys(val.accounts)) {
                let acc = val.accounts[account];
                if (acc != null) {
                  tempDataAccounts.push(acc.value);
                  tempColumnsNames.push(acc.account_description);
                }
              }
              this.columnNames[val.id] = tempColumnsNames;

              tempDataAccounts2.push("");
              for (let account2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[account2];
                if (acc2 != null) {
                  tempDataAccounts2.push(acc2.value);
                  tempColumnsNames2.push(acc2.account_description);
                }
              }
              this.columnNames2[val.id] = tempColumnsNames2;
            } else {
            }
          }
        },
        (err) => { }
      );
  }

  ngOnDestroy() {
    this.columnNames;
    this.columnNames2;
    this.textSlides;
    this.total;
    this.account;
    this.kpi;
    this.columnNames;
    this.allKpi;
    this.conclusion;
  }

  public convert(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  public convertWithToday(value) {
    const lastDayOfMonth = new Date(Number(this.fileYear), Number(this.fileMonthNumeric), 0);
    const dateString = lastDayOfMonth.getDate() + ' ' + this.fileMonth + ' ' + this.fileYear;


    // Find the last </p> tag and insert the date before it
    const lastPIndex = value.lastIndexOf('</p>');

    if (lastPIndex !== -1) {
      const enrichedValue = value.substring(0, lastPIndex) + ' ' + dateString + value.substring(lastPIndex);
      return this.sanitizer.bypassSecurityTrustHtml(enrichedValue);
    } else {
      // If no </p> tag found, just append the date
      return this.sanitizer.bypassSecurityTrustHtml(value + ' ' + dateString);
    }
  }

  public notesConvert(value, id) {
    let countStrings = value.split(" ").length;
    let strings = this.sanitizer.bypassSecurityTrustHtml(value);
    return strings;
  }

  public htmltoPDF() {
    this.loadingDownload = true;
    this.pdf = new jsPDF("p", "mm", "a4");
    this.length = this.textSlides.length;
    // this.length = 3
    this.counter = 0;

    this.generatePDF();
  }

  generatePDF() {
    let data = document.getElementById("slide_" + this.counter);

    html2canvas(data, {
      // scale: 3
    }).then((canvas) => {
      this.counter++;

      var imgWidth = 208;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;

      console.log(data);

      const contentDataURL = canvas.toDataURL("image/png");
      var position = 0;
      this.pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);

      if (this.counter < this.length) {
        console.log("addPage");
        this.pdf.addPage();
        this.generatePDF();
      } else {
        console.log("save");
        this.loadingDownload = false;
        this.pdf.save("test.pdf");
        return true;
      }
    });
  }

  public htmltohtml() {
    console.log(this.el.nativeElement.querySelector("#topHead").outerHTML.replace(/<!--[\s\S]*?-->/g, ""));
  }

  goToAnchor(id) {
    document.querySelector("#" + id).scrollIntoView();
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: any) { }

  public switchLanguage(language: string) {
    this.app.switchLanguage(language);
    this.sysLanguage = language;
    this.resetData();
    this.ngOnInit();
  }

  printReport() {
    this.isLanguageSelectorVisible = false;
    setTimeout(() => {
      window.print();
      this.isLanguageSelectorVisible = true;
    }, 0);
  }

  resetData(): void {
    this.loadingAccounts = true;
    this.loadingTotals = true;
    this.loadingKpi = true;
    this.loadingConclusions = true;
    this.loadingSlides = true;
    this.loadingExport = true;
  }

  toggleAllPanels(): void {
    this.allPanelsExpanded = !this.allPanelsExpanded;
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 992;
  }

  /**
   * Toggle afișare formular email
   */
  toggleEmailForm(): void {
    this.showEmailForm = !this.showEmailForm;
    if (!this.showEmailForm) {
      this.recipientEmail = '';
    }
  }

  /**
   * Validare adresă email
   */
  isValidEmail(email: string): boolean {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  }

  /**
   * Trimite raportul pe email
   */
  async sendReportByEmail(): Promise<void> {
    if (!this.isValidEmail(this.recipientEmail)) {
      this.message.error('Adresa de email nu este validă');
      return;
    }

    this.sendingEmail = true;
    const logoUrl = `${window.location.origin}/assets/img/db_pdf_logo.jpg`;

    try {
      // Găsește slide-urile
      const allSlides = document.querySelectorAll('[id^="slide_"]');

      if (allSlides.length === 0) {
        throw new Error('Nu s-au găsit slide-uri');
      }

      // Creează container
      const slidesContainer = document.createElement('div');
      slidesContainer.className = 'pdf-slides-container';

      // ============================================
      // CUPRINS (TABLE OF CONTENTS)
      // ============================================
      const cuprinsWrapper = document.createElement('div');
      cuprinsWrapper.className = 'pdf-slide-wrapper cuprins-page';

      const cuprinsTitle = document.createElement('div');
      cuprinsTitle.innerHTML = `
        <h1 style="text-align: center; margin-top: 2rem; margin-bottom: 2rem; font-size: 42px;">
          <strong>${this.fileMonth} ${this.fileYear}</strong><br>
        </h1>
      `;
      cuprinsWrapper.appendChild(cuprinsTitle);

      const chaptersData = [
        { num: '01', text: 'Analiza profitului de la venituri la rezultatul final (P&L)', color: '#1f92cc' },
        { num: '02', text: 'Diferența dintre PROFITul din balanță și CASH-ul din bancă', color: '#09c4a5' },
        { num: '03', text: 'Bilanțul - Averea Firmei și Sursele de Finanțare ale acesteia', color: '#ffb534' },
        { num: '04', text: 'Starea de Sănătate a Afacerii - KPI\'s - Indicatori Financiari', color: '#ff594a' },
        { num: '05', text: 'Informatii utile', color: '#e84393' }
      ];

      let cuprinsHtml = '<div style="padding: 0 40px 0 60px;">';
      chaptersData.forEach(ch => {
        cuprinsHtml += `
          <div style="position: relative; margin-bottom: 1.2rem; margin-left: 25px;">
            <div style="position: absolute; left: -30px; top: 50%; transform: translateY(-50%); width: 55px; height: 55px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: ${ch.color}; color: #fff; font-weight: 800; font-size: 28px; z-index: 1; box-shadow: 2px 2px 8px rgba(0,0,0,0.2);">${ch.num}</div>
            <div style="border: 3px solid ${ch.color}; border-radius: 8px; padding: 14px 15px 14px 40px; background: #fff; min-height: 45px; display: flex; align-items: center;">
              <p style="margin: 0; font-size: 22px; color: #333; font-weight: 700;">${ch.text}</p>
            </div>
          </div>
        `;
      });
      cuprinsHtml += '</div>';

      const cuprinsContent = document.createElement('div');
      cuprinsContent.innerHTML = cuprinsHtml;
      cuprinsWrapper.appendChild(cuprinsContent);

      slidesContainer.appendChild(cuprinsWrapper);

      // Slide-uri care încep o secțiune nouă (vor avea page-break-before)
      const sectionStarts = new Set([
        'slide_1',   // 1. Analiza profitului
        'slide_5',   // 2. Diferenta dintre PROFIT și CASH
        'slide_7',   // 3. Bilanțul
        'slide_9',   // 4. KPI's
        'slide_11',  // 5. Informatii utile
      ]);

      allSlides.forEach((slide) => {
        const slideElement = slide as HTMLElement;
        const slideId = slideElement.id;
        const textContent = slideElement.textContent?.trim() || '';
        const hasImages = slideElement.querySelectorAll('img').length > 0;
        const hasTables = slideElement.querySelectorAll('table').length > 0;

        if (textContent.length < 10 && !hasImages && !hasTables) {
          return;
        }

        const isSectionStart = sectionStarts.has(slideId);
        const slideWrapper = document.createElement('div');

        if (isSectionStart) {
          slideWrapper.className = 'pdf-slide-wrapper section-start';
        } else {
          slideWrapper.className = 'pdf-slide-wrapper';
        }

        const slideContent = document.createElement('div');
        slideContent.className = 'pdf-slide-content';
        slideContent.innerHTML = slideElement.innerHTML;
        slideWrapper.appendChild(slideContent);

        slidesContainer.appendChild(slideWrapper);
      });

      // Elimină elementele UI
      const selectorsToRemove = [
        '.print-btn', '.email-btn', '.action-buttons-row',
        '.email-form-container', '.print-pdf', '.print-buttons',
        '.notes-btn-container', '.notes-form-container'
      ];

      selectorsToRemove.forEach(selector => {
        slidesContainer.querySelectorAll(selector).forEach(el => el.remove());
      });

      // Convertește imagini la URL absolute
      slidesContainer.querySelectorAll('img').forEach((img: HTMLImageElement) => {
        const src = img.getAttribute('src');
        if (src && !src.startsWith('data:') && !src.startsWith('http')) {
          img.setAttribute('src', new URL(src, window.location.origin).href);
        }
      });

      // Forțează font pe tot conținutul dinamic
      const pdfFont = "'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif";

      // Elimină <style> tags din conținutul slide-urilor
      slidesContainer.querySelectorAll('style').forEach(el => el.remove());

      // Înlocuiește <font> tags cu <span>
      slidesContainer.querySelectorAll('font').forEach(el => {
        const span = document.createElement('span');
        span.innerHTML = el.innerHTML;
        el.replaceWith(span);
      });

      // Forțează fontul pe toate elementele text
      slidesContainer.querySelectorAll('p, span, div, li, ul, ol, h1, h2, h3, h4, h5, h6, td, th, tr, table, strong, em, b, i, a, label, blockquote, caption, figcaption, pre, code').forEach((el: HTMLElement) => {
        el.style.setProperty('font-family', pdfFont, 'important');
        el.style.removeProperty('font');
      });

      // Capturează CSS (fără @font-face)
      let capturedStyles = '';
      for (const sheet of Array.from(document.styleSheets)) {
        try {
          for (const rule of Array.from(sheet.cssRules)) {
            if (rule instanceof CSSMediaRule && rule.conditionText === 'print') {
              continue;
            }
            if (rule instanceof CSSMediaRule && rule.conditionText.includes('max-width')) {
              continue;
            }
            if (rule instanceof CSSFontFaceRule) {
              continue;
            }
            capturedStyles += rule.cssText + '\n';
          }
        } catch (e) {
          // Cross-origin
        }
      }

      // Strip ALL font-family declarations from captured styles
      capturedStyles = capturedStyles.replace(/font-family\s*:[^;}]+;?/gi, '');

      // Add explicit styles for email
      const emailTableStyles = `
        * {
          font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important;
        }
        body {
          font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important;
          font-size: 19px !important;
          line-height: 1.5 !important;
        }
        body * {
          font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important;
        }

        /* ========== TOP/BOTTOM HEADERS ========== */
        .top-header {
          background-color: #fff !important;
          padding: 30px 0 !important;
        }
        .top-header:before,
        .bottom-header:before {
          opacity: 0.1 !important;
        }
        .bottom-header {
          background-color: #f1f1f1 !important;
          padding: 15px 0 !important;
        }

        /* ========== TYPOGRAPHY ========== */
        h1 {
          font-size: 38px !important;
          font-weight: 800 !important;
          margin-bottom: 15px !important;
        }
        h2 {
          font-size: 34px !important;
          font-weight: 700 !important;
          margin-bottom: 12px !important;
        }
        h3 {
          font-size: 30px !important;
          font-weight: 700 !important;
          margin-bottom: 2px !important;
          line-height: 1.4 !important;
        }
        .p-title,
        h3.p-title,
        .top-header h3.p-lg {
          padding-bottom: 0.5rem !important;
          margin-bottom: 1.5rem !important;
        }
        .p-title:after,
        .kpi-line:after {
          bottom: 0 !important;
        }
        .p-content h3 {
          margin-bottom: 18px !important;
          line-height: 1.5 !important;
        }
        h4 {
          font-size: 24px !important;
          font-weight: 600 !important;
          margin-bottom: 8px !important;
        }
        p {
          font-size: 19px !important;
          margin-bottom: 10px !important;
          line-height: 1.6 !important;
        }
        li {
          font-size: 18px !important;
          line-height: 1.6 !important;
        }

        /* ========== CUPRINS ========== */
        .pdf-slide-wrapper:first-child p {
          font-size: 24px !important;
          font-weight: 700 !important;
        }
        .cuprins-page {
          page-break-after: always !important;
          break-after: page !important;
        }

        /* ========== SLIDE WRAPPER ========== */
        .pdf-slide-wrapper {
          padding: 20px 20px 0 20px !important;
          margin: 0 !important;
          background: white !important;
        }

        /* ========== SECȚIUNI PRINCIPALE - PAGE BREAK ÎNAINTE ========== */
        .pdf-slide-wrapper.section-start {
          page-break-before: always !important;
          break-before: page !important;
        }

        /* ========== TABLES ========== */
        .ant-table-thead > tr > th {
          background: #28b5b5 !important;
          color: white !important;
          font-weight: 600 !important;
          padding: 10px 8px !important;
          font-size: 19px !important;
        }
        .ant-table-tbody > tr > td {
          padding: 8px !important;
          font-size: 19px !important;
          border-bottom: 1px solid #e8e8e8 !important;
        }
        table {
          font-size: 19px !important;
        }
        table th, table td {
          font-size: 19px !important;
          padding: 8px !important;
        }

        /* ========== TITLE CONTENT (2 COLUMNS) ========== */
        .title-content {
          display: flex !important;
          flex-direction: row !important;
          gap: 20px !important;
        }
        .title-content > div {
          flex: 1 !important;
          width: auto !important;
        }

        /* ========== QUOTE CARDS ========== */
        ul.title-content.footer-quotes-cards {
          display: flex !important;
          flex-direction: row !important;
          gap: 20px !important;
          list-style: none !important;
          padding: 0 !important;
        }
        ul.title-content.footer-quotes-cards > li {
          flex: 1 !important;
          max-width: 50% !important;
        }

        /* ========== REPORT INFO ========== */
        .report-info {
          border-radius: 25px !important;
          padding: 10px 20px !important;
          margin: 15px 0 !important;
        }
        .report-info div {
          padding: 8px !important;
          font-size: 18px !important;
        }

        /* ========== PAGE BREAKS ========== */
        @page {
          size: A4;
          margin: 15mm 10mm;
        }
        table {
          page-break-inside: avoid !important;
        }
        h1, h2, h3, h4 {
          page-break-after: avoid !important;
        }
        img {
          page-break-inside: avoid !important;
          max-width: 100% !important;
        }
      `;

      const slidesHtml = slidesContainer.outerHTML;

      const htmlContent = `
<!DOCTYPE html>
<html lang="ro">
<head>
  <meta charset="UTF-8">
  <title>Raport Financiar Simplificat - Doctor Business</title>
  <style>${capturedStyles}</style>
  <style>${emailTableStyles}</style>
</head>
<body style="font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important;">
  <div style="text-align: center; padding: 20px; border-bottom: 2px solid #28b5b5; margin-bottom: 15px;">
    <img src="${logoUrl}" alt="Doctor Business" style="height: 54px;">
  </div>
  ${slidesHtml}
  <style>
    *, *::before, *::after { font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important; }
  </style>
</body>
</html>
      `.trim();

      this.message.loading('Se trimite raportul... Vă rugăm așteptați.', { nzDuration: 0 });

      const formData = new FormData();
      formData.append('email', this.recipientEmail.trim());
      formData.append('html_content', htmlContent);

      await this.http.post(this.apiUrl + '/send-report-email', formData).toPromise();

      this.message.remove();
      this.message.success('Raportul a fost trimis cu succes!');
      this.showEmailForm = false;
      this.recipientEmail = '';

    } catch (error: any) {
      console.error('Eroare:', error);
      this.message.remove();
      this.message.error(error?.error?.message || 'Eroare la trimiterea email-ului.');
    } finally {
      this.sendingEmail = false;
    }
  }

  /**
   * Toggle afișare formular notițe
   */
  toggleNotesForm(): void {
    this.showNotesForm = !this.showNotesForm;
  }

  /**
   * Încarcă notițele fișierului din baza de date
   */
  loadFileNotes(): void {
    const fileId = localStorage.getItem("fileId");
    if (!fileId) {
      return;
    }

    this.http.get<any>(this.apiUrl + "/file/notes/" + fileId, {
      observe: "response",
    }).subscribe({
      next: (res: any) => {
        if (res.body && res.body.notes !== undefined) {
          this.fileNotes = res.body.notes || '';
        } else if (typeof res.body === 'string') {
          this.fileNotes = res.body;
        }
      },
      error: (err) => {
        console.error('Error loading file notes:', err);
        this.fileNotes = '';
      }
    });
  }

  /**
   * Salvează notițele fișierului
   */
  saveFileNotes(): void {
    const fileId = localStorage.getItem("fileId");

    if (!fileId) {
      this.message.error('ID-ul fișierului nu a fost găsit');
      return;
    }

    this.savingNotes = true;
    const noteData = { notes: this.fileNotes };
    const loadingMsgId = this.message.loading('Se salvează notițele...', { nzDuration: 0 }).messageId;

    this.http.put(this.apiUrl + "/file/notes/" + fileId, noteData, {
      observe: "response",
    }).subscribe({
      next: (res: any) => {
        this.message.remove(loadingMsgId);
        this.message.success('Notițele au fost salvate cu succes!');
        this.showNotesForm = false;
        this.savingNotes = false;
      },
      error: (err) => {
        console.error('Error saving notes:', err);
        this.message.remove(loadingMsgId);
        this.message.error('Eroare la salvarea notițelor');
        this.savingNotes = false;
      }
    });
  }
}
